<div class="profile-details">
  <div class="row text-center">
    <div class="col"> 
        <div class="header-icon full-icon">
          <svg-phone-svg></svg-phone-svg>
        </div>
        <div *ngIf="whereInTheProcess==='edit-phone';else addPhone">
          <h1 class="title-copy">{{ 'PROFILE_PHONE_ONE' | translate }}</h1>
        </div>
        <ng-template #addPhone>
          <h1 class="title-copy">{{ 'PROFILE_PHONE_TWO' | translate }}</h1>
        </ng-template>
    </div>
  </div>
  <app-change-phone [inputs]='accountPhoneForm'></app-change-phone>
</div>